import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
   // CognitoUserAttribute
} from 'amazon-cognito-identity-js'
import { CognitoIdentityCredentials, config } from 'aws-sdk'
import awsConfig from './../config'
import store from './../store'



export default class Cognito {
    configure(configure) {
        if (configure.userPool) {
            this.userPool = configure.userPool
        } else {
            this.userPool = new CognitoUserPool({
                UserPoolId: configure.UserPoolId,
                ClientId: configure.ClientId,
                Storage: sessionStorage
            })
        }

        config.region = configure.Region

        this.options = configure
        this.currentUser = false
    }

    static install = (Vue, options) => {
        Object.defineProperty(Vue.prototype, '$cognito', {
            get() { return this.$root._cognito }
        })


        Vue.mixin({
          beforeCreate() {
                if (this.$options.cognito) {
                    this._cognito = this.$options.cognito
                    this._cognito.configure(options)
                }
            }
        })
    }

    //���[�U�̃O���[�v��ύX����
    changeGroup(username, userclass, flg) {
        const AWS = require('aws-sdk')
        //const credential = awsConfig.AWSConfig.Credential//eslint-disable-line

        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        //�F�؏����N���f���V�����ɕϊ�
        var logins = {}
        logins['cognito-idp.' + awsConfig.AWSConfig.Region + '.amazonaws.com/' + awsConfig.AWSConfig.UserPoolId] = sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins: logins,
            Storage: sessionStorage

        })
        //���[�U���
        var params = {
            UserPoolId: awsConfig.AWSConfig.UserPoolId,
            Username: username,
            GroupName: "admin"
        };

        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        if (flg == 0) {//�O���[�v�ւ̒ǉ�
            return new Promise((resolve, reject) => {
                if (userclass == 1 || userclass == 2) {
                    cognitoidentityserviceprovider.adminAddUserToGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                } else {
                    resolve("��ʃ��[�U")
                }

            })
        } else if (flg == 1) {
            return new Promise((resolve, reject) => {
                if (userclass == 1 || userclass == 2) {
                    cognitoidentityserviceprovider.adminAddUserToGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                } else {
                    cognitoidentityserviceprovider.adminRemoveUserFromGroup(params, (err, result) => {
                        AWS.config.credentials.clearCachedId()
                        if (err) {
                            reject(err)
                        }
                        else {
                            resolve(result)
                        }
                    })
                }
            })
        }
    }

    //�T�C���A�b�v
    signUp(username, email,flg,tmpPassword) {
        const AWS = require('aws-sdk')
        
        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        var logins = {}
        logins['cognito-idp.' + awsConfig.AWSConfig.Region + '.amazonaws.com/' + awsConfig.AWSConfig.UserPoolId] = sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins:logins,
            Storage: sessionStorage

        })


        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        var params
        var password
        if (tmpPassword == null || tmpPassword == "") {
            password = this.makePassword();
        }
        else
        {
            password = tmpPassword;
        }

        if (flg == 1) {
            //���[�U���
            params = {
                UserPoolId: awsConfig.AWSConfig.UserPoolId,
                Username: username,
                DesiredDeliveryMediums: [                   //���҃��b�Z�[�W
                    'EMAIL'
                ],
                TemporaryPassword: password,          //�ݒ肵�Ȃ���Ύ����Ő���        
                UserAttributes: [
                    {
                        Name: 'email',
                        Value: email
                    },
                    {
                        Name: 'name',
                        Value: username
                    },
                    {
                        Name: 'email_verified',
                        Value: 'true'
                    }
                ]
            };

            return new Promise((resolve, reject) => {
                cognitoidentityserviceprovider.adminCreateUser(params, (err, result) => {
                    AWS.config.credentials.clearCachedId()
                    if (err) {
                        reject(err)
                    }
                    else {
                        resolve(result.User.Attributes[0].Value)
                    }
                })

            })


        } else if (flg == 2) {
             params = {
                 UserPoolId: awsConfig.AWSConfig.UserPoolId,
                Username: username,
                UserAttributes: [
                    {
                        Name: 'email',
                        Value: email
                    },
                    {
                        Name: 'email_verified',
                        Value: 'true'
                    }
                ]
            };
            return new Promise((resolve, reject) => {
                cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err, result) => {
                    AWS.config.credentials.clearCachedId()
                    if (err) {
                        reject(err)
                    }
                    else {
                        resolve(result)
                    }
                })

            })
        }

        
        
    }

    //�Ǘ��҂ɂ�郆�[�U�̍폜
    deleteUser(username) {
        const AWS = require('aws-sdk')
        //const credential = awsConfig.AWSConfig.Credential//eslint-disable-line

        AWS.config.update({ region: awsConfig.AWSConfig.Region })

        //���[�U���
        var params = {
            UserPoolId: awsConfig.AWSConfig.UserPoolId,
            Username: username,
        };

        var logins = {}
        logins['cognito-idp.' + awsConfig.AWSConfig.Region + '.amazonaws.com/' + awsConfig.AWSConfig.UserPoolId] = sessionStorage.getItem("CognitoIdentityServiceProvider." + awsConfig.AWSConfig.ClientId + "." + store.getters.getUserId + ".idToken")

        AWS.config.credentials = new CognitoIdentityCredentials({
            IdentityPoolId: awsConfig.AWSConfig.IdentityPoolId,
            Logins: logins,
            Storage: sessionStorage

        })


        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({});

        return new Promise((resolve, reject) => {
            cognitoidentityserviceprovider.adminDeleteUser(params, (err, result) => {
                AWS.config.credentials.clearCachedId()
                if (err) {
                    reject(err)
                }
                else {
                    resolve(result)
                }
            })

        })
    }


    //�����_���ȃp�X���[�h�𐶐�
    makePassword() {
        const source = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_?!#$%&'
        const sLetter = /^(?=.*[a-z])/
        const lLetter = /^(?=.*[A-Z])/
        const num = /^(?=.*[0-9])/
        const symbol = /^(?=.*[_?!#$%&])/
        const length = 8
        var result = ''

        while (length == 8 ) {
            result = ''
            for (var i = 0; i < length; i++) {
                result += source.charAt(Math.floor(Math.random()*source.length))
            }
            if (sLetter.test(result) && lLetter.test(result) && num.test(result) && symbol.test(result)) {
                break
            }
        }

        return result
    }

    

     //���O�C��
    signin(username, password) {
        const userData = { Username: username, Pool: this.userPool ,Storage:sessionStorage}
        const cognitoUser = new CognitoUser(userData)
        const authenticationData = { Username: username, Password: password }
        const authenticationDetails = new AuthenticationDetails(authenticationData)
        return new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                },
                newPasswordRequired: function () {
                    cognitoUser.completeNewPasswordChallenge(password, {}, this)
                }
            })
        })
    }

 

    // �T�C���A�E�g
    signout() {
        if(this.userPool.getCurrentUser()) {
            this.userPool.getCurrentUser().signOut()
        }
    }
    

    // �F�؂��݂��ǂ���
    isAuthenticated() {
        this.currentUser = this.userPool.getCurrentUser()
        return new Promise((resolve, reject) => {
            if (this.currentUser === null) { reject(this.currentUser) }
            this.currentUser.getSession((err, session) => {
                if (err) {
                    reject(err)
                } else {
                    if (!session.isValid()) {
                        reject(session)
                    } else {
                        resolve(session)
                    }
                }
            })
            
        })
    }

    // �p�X���[�h�X�V
    updatePassword(oldPassword, newPassword) {
        return new Promise((resolve, reject) => {
            this.currentUser.changePassword(oldPassword, newPassword, (err, result) => {
                if (err) {
                    reject(err)
                }
                else {
                    resolve(result)
                }
            })
        })
    }

    // �p�X���[�h�Y�ꃁ�[�����M
    forgetPassword(username) {
        const userData = { Username: username, Pool: this.userPool }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.forgotPassword({
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                }
            })
        })
    }

    // �p�X���[�h���Z�b�g
    resetPassword(username, newPassword, code) {
        const userData = { Username: username, Pool: this.userPool }
        const cognitoUser = new CognitoUser(userData)
        return new Promise((resolve, reject) => {
            cognitoUser.confirmPassword(code, newPassword, {
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                }
            })
        })
    }

    //���[���A�h���X�ύX
    updateEmailAddress(email) {
        var attributes = {
            Name: 'email',
            Value: email
        }
        var attributeList = []
        attributeList.push(attributes)

        return new Promise((resolve, reject) => {
            this.currentUser.updateAttributes(attributeList, (err, result) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(result)
                }
            })
        })
    }

    //���[���A�h���X����
    verifyAttribute(confirmationCode) {
        return new Promise((resolve, reject) => {
            this.currentUser.verifyAttribute("email", confirmationCode, {
                onSuccess: (result) => {
                    resolve(result)
                },
                onFailure: (err) => {
                    reject(err)
                }
            })
        })
  }

  /**
   * ���ȃT�C���A�b�v
   */
  selfSignUp(userId, email) {
    const params = [{"Name":"email","Value":email}]

    return new Promise((resolve, reject) => {
      this.userPool.signUp(userId, this.makePassword() ,params,null, (err, result) => {
        if (err) {
          reject(err)
        }
        else {
          resolve(result)
        }
      })
    })
  }

  /**
   * ���[���A�h���X�F��
   */
  mailConfirm(userId, code) {
    const userData = { Username: userId, Pool: this.userPool }
    const cognitoUser = new CognitoUser(userData)
    return new Promise((resolve, reject) => {
      cognitoUser.confirmRegistration(code, true, (err, result) => {
        if (err) {
          reject(err)
        }
        else {
          resolve(result)
        }
      })
    })
  }

}